import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cocoa from "../media/CocoaBean.webp";
import {
  faWhatsapp,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-black/90 text-yellow-100 pt-12 pb-6 px-4">
      <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center md:items-start justify-between gap-10">
        {/* Left: Brand & Social */}
        <div className="flex flex-col items-center md:items-start mb-4 md:mb-0">
          <img
            src={cocoa}
            alt="Van Belle Chocolatier Premium Cocoa Bean Logo - Belgian Chocolate Excellence"
            className="h-20 w-30 mb-4"
          />
          <div className="flex space-x-6 mb-2">
            <a
              href="https://wa.me/96176919011"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="transition-transform transform hover:scale-110 hover:bg-lime-400/20 rounded-full p-2"
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                className="h-8 w-8 text-lime-400"
              />
            </a>
            <a
              href="https://www.facebook.com/Vanbelle.lb?mibextid=LQQJ4d"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="transition-transform transform hover:scale-110 hover:bg-sky-500/20 rounded-full p-2"
            >
              <FontAwesomeIcon
                icon={faFacebook}
                className="h-8 w-8 text-sky-500"
              />
            </a>
            <a
              href="https://www.instagram.com/vanbelle.lb/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="transition-transform transform hover:scale-110 hover:bg-orange-400/20 rounded-full p-2"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                className="h-8 w-8 text-orange-400"
              />
            </a>
          </div>
          <span className="text-sm text-yellow-200/80 mt-2 mb-2">
            Follow us for the latest creations
          </span>
        </div>
        <div className="flex-1 text-center md:text-left mb-8 md:mb-0">
   
          <div className="text-lg">
            <div>
              <span className="font-semibold">Phone:</span> +961 06 431 985
            </div>
            <div>
              <span className="font-semibold">WhatsApp:</span>{" "}
              <a
                href="https://wa.me/96176919011"
                className="underline hover:text-lime-400"
                target="_blank"
                rel="noopener noreferrer"
              >
                +961 76 919 011
              </a>
            </div>
            <div>
              <span className="font-semibold">Email:</span>{" "}
              <a
                href="mailto:info@vanbelle-lb.com"
                className="underline hover:text-yellow-200"
              >
                info@vanbelle-lb.com
              </a>
            </div>
            <div className="mt-2">
              Hazem El Jisir Street, Facing St Familie School
            </div>
          </div>
        </div>
        {/* Right: Map & Action */}
        <div className="flex flex-col items-center md:items-end self-stretch justify-between">
          <a
            href="https://maps.app.goo.gl/7PQF3VH4TTaEFaKP6"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 mb-4 rounded-full border border-yellow-100 text-yellow-100 font-medium hover:bg-yellow-100 hover:text-black transition"
          >
            Visit Our Store
          </a>
          <iframe
            className="rounded-lg shadow-lg w-64 h-40 border-2 border-yellow-900"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13162.360509906988!2d35.8317263!3d34.4371649!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1521f6ab8b9426b5%3A0x6f20da7b0cf352a5!2sChocolatier%20Van%20Belle!5e0!3m2!1sen!2slb!4v1709489804131!5m2!1sen!2slb"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Van Belle Location"
          ></iframe>
        </div>
      </div>
      <hr className="my-8 border-yellow-900/60" />
      <nav aria-label="Footer" className="mb-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
        <Link to="/track-order" className="text-yellow-100 hover:text-white hover:underline">Track your order</Link>
        <Link to="/about" className="text-yellow-100 hover:text-white hover:underline">About us</Link>
        <Link to="/privacy-policy" className="text-yellow-100 hover:text-white hover:underline">Privacy policy</Link>
      </nav>
      <p className="text-center text-yellow-200/80 text-sm">
        © {new Date().getFullYear()} Chocolatier Van Belle. All rights reserved.
        {/* <a
          href="/admin"
          className="ml-4 text-yellow-200/60 hover:text-yellow-200/90 text-xs underline transition-colors duration-200"
        >
          Admin
        </a> */}
      </p>
    </footer>
  );
};

export default Footer;